export default __webpack_public_path__ + "static/media/manage-account.14a71f38.png";